/* globals Forms, DOMParser, moment */
import { parseFlexibleDate } from './parseFlexibleDate'

window.Forms || (window.Forms = {})

Forms.initForm = function (element) {
  Forms.initAutosize(element)
  Forms.initCheckbox(element)
  Forms.initTooltips(element)
  Forms.initDatePickers(element)
  Forms.initFileInputs(element)
  Forms.initInputMasks(element)
  Forms.initMinicolors(element)
  Forms.initSelect2(element)
  Forms.initSelect2Tags(element)
  Forms.initCurrencyInputs(element)
  Forms.initUnsavedForms()
  Forms.initAutoSubmit()
  Forms.initScrollableLabel()
  Forms.initScheduleUpdateHint()
  Forms.smoothScrollingOnIOS()
}

Forms.initTooltips = function (element) {
  $('[rel=tooltip], [data-bs-toggle=tooltip]', element).each(function () {
    const placement = $(this).data('placement') || 'top'
    window.createTooltips(this, { placement, title: '' })
  })

  $('[rel=tooltip], [data-bs-toggle=tooltip]', element).each(function () {
    window.createTooltips($(this), {
      container: 'body',
      template: '<div class="tooltip tooltip-lg" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>'
    })
  })
}

Forms.initScheduleUpdateHint = function (element) {
  const inputs = element ? [element] : document.querySelectorAll('.form-control[data-delayed-update-date]')
  inputs.forEach((input) => {
    const newValue = input.dataset.delayedUpdateValue || '—'
    const date = input.dataset.delayedUpdateDate
    input.setAttribute('disabled', true)
    input.classList.add('delayed-update')
    if (input.dataset.select2) {
      $(input).select2('disable')
      input = $(input).data('select2').container
    }
    window.createTooltips(input.parentElement, { title: `<div>${newValue}</div><div class="text-muted">${date}</div>`, html: true, placement: 'top', trigger: 'hover' })
  })
}

Forms.initAutosize = function (element) {
  const autosize = require('autosize/dist/autosize')
  const $textarea = $('textarea.autosize')
  autosize($textarea, element)
  autosize.update($textarea, element)
  $('a[data-bs-toggle="tab"]').on('shown.bs.tab', function () {
    return autosize.update($textarea, element)
  })
}

Forms.initSelect2 = function (element) { // pass select tag or parent element
  const select = $(element).is('select') ? $(element) : $('select.select2, select.select2-width-resolve', element)
  const option = '.select2-search-choice>div, .select2-chosen'
  const result = '.select2-result-label'

  const matcher = (params, data) => {
    if (params == null || params.trim() === '') {
      return data
    }

    const index = window.FlexSearch.Index({
      tokenize: 'full',
      charset: 'latin:strict'
    })

    index.add('0', data)

    if (index.search(params).length > 0) {
      return data
    }

    return null
  }

  const extraOptions = { matcher }
  if ($(element).data('enableHtml')) {
    extraOptions.escapeMarkup = (val) => val
  }

  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)

  // On mobile: don't auto-focus search input to prevent keyboard from opening immediately
  // User can tap on search field to open keyboard when needed
  if (isMobile) {
    extraOptions.shouldFocusInput = () => false
  }

  $(select).each(function () {
    const $this = $(this)

    const inHiddenSide = $this.closest('#hidden-side').length > 0

    // Outside the hidden side: keep the native <select> fallback on small viewports.
    if (window.innerWidth <= 768 && !inHiddenSide) {
      if ($this.data('select2')) $this.select2('destroy')
      if ($this.prop('multiple')) {
        const optionCount = $this.find('option').length
        if (optionCount > 0) $this.attr('size', Math.min(optionCount, 6))
      }
      return
    }

    // Avoid reinitializing a live Select2 instance (prevents destroyed-search focus errors).
    if ($this.data('select2')) return

    // Prevent Select2's init-time focus() from firing on a select that has just been set up.
    $this.removeAttr('autofocus')

    const widthResolve = $this.parents('.form-group').css('display') === 'table' || $this.hasClass('select2-width-resolve')
    const allowClear = $this.hasClass('select2-allow-clear')
    if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) $this.addClass('ios-device')
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) $this.addClass('ios-device')
    const select2 = $this.select2('destroy').select2({
      createSearchChoicePosition: 'top',
      width: widthResolve ? 'resolve' : 'copy',
      allowClear,
      dropdownCssClass: `${$this.attr('id')}_select2_results`,
      ...extraOptions
    }).data('select2')
    select2.search.attr('autocomplete', 'off')
    select2.selection.find(option).toHtmlTags()
    select2.select.on({
      'select2-loaded': () => select2.results && select2.results.find(result).toHtmlTags(),
      'select2-close': () => select2.selection && select2.selection.find(option).toHtmlTags(),
      'change.select2': () => select2.selection && select2.selection.find(option).toHtmlTags(),
      focus: (e) => e.preventDefault(),
      focusin: (e) => e.preventDefault()
    })

    // Allow clear hack
    if (allowClear) {
      handleAllowClear(select2)
      select2.select.on('change', () => handleAllowClear(select2))
    }

    // Fix for mobile: add touch event handler for clear button (works for all selects)
    if (isMobile && select2.container) {
      // Prevent default touch behavior on abbr to avoid dropdown closing
      select2.container.on('touchstart', 'abbr', function (e) {
        e.stopPropagation()
        e.preventDefault()
      })
      select2.container.on('touchend', 'abbr', function (e) {
        e.preventDefault()
        e.stopPropagation()
        e.stopImmediatePropagation()

        // Get the underlying select element
        const $selectElement = select2.select || $this

        // Clear using Select2 API - set to empty option value
        $selectElement.select2('val', '')

        // Also clear the native select
        $selectElement.val('')

        // Trigger change event
        $selectElement.trigger('change')

        // Close the dropdown
        select2.close()

        return false
      })
    }
  })

  function handleAllowClear (select2) {
    if (select2.container) {
      select2.container.toggleClass('select2-allowclear', !!select2.val())
    }
  }
}

Forms.initSelect2Tags = function (element) {
  $('.select2-tokenized', element).each(function () {
    const input = $(this)
    input.select2({
      tags: input.attr('data-tags').split(','),
      tokenSeparators: [',', ' '],
      width: 'copy',
      dropdownAutoWidth: true
    })
  })
}

Forms.initUnsavedForms = function () {
  $('form.safe-leaving').each(function (i, el) {
    el.isDirty = false
    el.isSubmited = false
    $(el).on('submit', function (e) {
      el.isSubmited = true
    })
  })
  $(document).on('change', $(':input'), function (e) {
    e.originalEvent && e.target.form && (e.target.form.isDirty = true)
  })
  const checkUnsavedForms = function () {
    const unsavedForms = $('form.safe-leaving').filter(function (i, form) {
      return !form.isSubmited && form.isDirty
    })
    return unsavedForms.length > 0
  }
  window.onbeforeunload = function (e) {
    let dialogText
    if (checkUnsavedForms()) {
      dialogText = 'You have entered some data and have not saved it. Do you want to leave?'
      e.returnValue = dialogText
      return dialogText
    }
  }
}

Forms.initInputMasks = function (element) {
  const input = $(element).is('input') ? $(element) : $('input.url-mask', element)
  input.each(function () {
    $(this).attr('type', 'text').inputmask({
      definitions: {
        i: {
          validator: '.',
          cardinality: 1
        }
      },
      mask: '(\\http://)|(\\http\\s://)|(ftp://)|(ftp\\s://)i{+}',
      insertMode: !1,
      autoUnmask: !1,
      inputmode: 'url'
    })
  })
}

Forms.initFileInputs = function (fileBlock) {
  $('.upload-file', fileBlock).each(function () {
    const block = $(this)
    const input = block.find('input')
    const btn = block.find('.upload-file-button')
    const accepted = (input.attr('accept') && input.attr('accept').split(', ')) || []

    input.on('dragover dragleave drop', (e) => block.toggleClass('hover', e.type === 'dragover'))
    btn.unbind('click').click(function (e) {
      e.preventDefault()

      // Direct-upload flows (e.g. ImageWithCropper) disable the input once a file
      // finishes uploading (their own hidden input carries the signed_id instead) -
      // re-enable it so it's clickable again.
      const el = input[0]
      el.disabled = false

      input.click()
    })
    input.change(function (e) {
      block.find('span.file-name').remove()
      let errorFilesNumber = 0
      if (accepted.length > 0) {
        _.each(e.target.files, (f) => {
          const type = '.' + _.last(f.name.split('.'))
          if (accepted.indexOf(type.toLowerCase()) === -1) errorFilesNumber++
        })
      }
      if (errorFilesNumber === 0) {
        _.each(e.target.files, (f) => {
          const fileName = f.name.replace(/^.*[/|\\]([\w-_ ]+\.\w+)$/, '$1')
          const label = $(`<span class="file-name">${fileName}</span>`)
          block.append(label)
        })
      } else {
        input.val('')
        block.addClass('error')
        setTimeout(function () { block.removeClass('error') }, 2000)
      }
    })
  })
}

Forms.initDblClickTextarea = function (element) {
  const autosize = require('autosize/dist/autosize')
  $('textarea', element).off('dblclick.timestamp').on('dblclick.timestamp', function () {
    const textarea = $(this)
    if (textarea.attr('readonly') || textarea.attr('disabled')) { return }

    const username = (window.gon?.application?.user_name || $('#nav-username').text()).trim()
    const date = moment()
    const text = date.format('DD.MM.YYYY HH:mm') + ' ' + username
    textarea.val('[' + text + ']\n\n' + textarea.val())
    textarea.trigger('input').focus()
    textarea[0].setSelectionRange(text.length + 3, text.length + 3)
    autosize.update(textarea)
  })
}

Forms.initCheckbox = function (element) {
  $('label.checkbox, label.switchery, label.radio, .radio > label, .checkbox > label', element).each(function () {
    if ($(this).find('.box').length === 0) $(this).append('<span class="box"></span>')
    const label = $(this)
    const input = label.find('input[type="checkbox"], input[type="radio"]').first()
    const isRememberMe = (input.attr('name') || '').includes('[remember_me]')

    if (isRememberMe) {
      label.addClass('force-no-border-radius')
    }

    // if label has more than 1 input
    label.on('click', function (e) {
      const id = label.attr('for')
      if (id && label.find('input[type="checkbox"], input[type="radio"]').length > 1) {
        e.preventDefault()
        label.find(`input#${id}`).prop('checked', !label.prop('checked'))
      }
    })
  })
}

Forms.initDatePickers = function (element) {
  const ConfirmDatePlugin = require('flatpickr/dist/plugins/confirmDate/confirmDate')
  $('#new_search input.datepicker', element).each(function (i) {
    $(this).attr('id', $(this).attr('id') + '-' + i)
  })

  $('input.datepicker, input.datetimepicker', element).each(function () {
    const FORMAT = 'DD.MM.YYYY HH:mm'
    const el = $(this)
    let options = {}
    const additionalOptions = el.data('datepicker-options')
    options = $.extend(options, additionalOptions)

    // Scoped to plain .datepicker (date-only) elements rather than flatpickr's global default
    // config: parseFlexibleDate's digit-count branching assumes no time component, which would
    // misparse a .datetimepicker's "DD.MM.YYYY HH:mm" value.
    if (!el.is('.datetimepicker')) {
      options.parseDate = parseFlexibleDate
    }

    // Reformat Default/Min/Max dates and shortcuts ('now', 'tomorrow')
    const dateKeys = ['minDate', 'maxDate', 'defaultDate']
    dateKeys.forEach((key) => {
      if (additionalOptions && additionalOptions[key]) {
        const date = additionalOptions[key]
        if (!isNaN(Date.parse(date))) {
          // Date passed
          options[key] = moment(date).startOf('day')._d
        } else {
          // Shortcut passed
          if (date === 'now') { options[key] = new Date() }
          if (date === 'today') { options[key] = moment().startOf('day')._d }
          if (date === 'tomorrow') { options[key] = moment().startOf('day').add(1, 'days').add(10, 'hours').format(FORMAT) }
        }
      }
    })

    // Datetimepicker
    if (el.is('.datetimepicker')) {
      options.enableTime = true
      options.dateFormat = 'd.m.Y H:i' // the same as DD.MM.YYYY HH:mm
      options.plugins = [new ConfirmDatePlugin({
        confirmIcon: `<span class="flatpickr_confirm_${el.attr('id')}" style='display: none'></span>`,
        confirmText: I18n.t('calendar.actions.apply'),
        showAlways: false,
        theme: 'light'
      })]
    }

    // Prevent insert value after initialization
    if (options.defaultDate && options.preventUseCurrent) {
      options.onReady = () => el.val('')
      options.onOpen = () => {
        if (options.defaultDate) el.val(options.defaultDate)
        options.defaultDate = null
      }
    }
    if (options.inline) el.addClass('flatpickr-input-inline')
    el.attr('autocomplete', 'off')
    el.flatpickr(options)
  })
}

Forms.initSliders = function (form) {
  $('.ui-slider', form).each(function () {
    const slider = $(this)
    const target = $(slider.data('target'), form)

    return slider.slider({
      min: 0,
      step: 10,
      max: slider.data('max'),
      range: 'min',
      value: parseFloat(target.val() || 0),
      slide: function (e, ui) {
        if (ui.value) {
          return target.val(ui.value).removeClass('hidden')
        } else {
          return target.val('').addClass('hidden')
        }
      }
    })
  })
}

Forms.enable_assign_button = function (select) {
  $(document).on('change', '#' + select, function (e) {
    const form = $('#' + select).parents('form')
    form.find('input[type=submit]').attr('disabled', false)
  })
}

Forms.disabledFieldsHiddenizer = function (formId, fieldType) {
  fieldType = fieldType || ''
  $(`${formId} ${fieldType}:disabled`).each(function (_, element) {
    const hiddenVersion = buildHiddenVersion($(element))
    $(element).on('change', (e) => {
      hiddenVersion.val($(e.target).val())
    })
  })

  function buildHiddenVersion (element) {
    return jQuery('<input/>', {
      id: (element.get(0).id) + '_hidden',
      name: '' + (element.get(0).name),
      type: 'hidden',
      value: element.val()
    }).insertBefore(element)
  };
}

Forms.initMinicolors = function (elements) {
  $('input.color', elements).each(function () {
    const el = $(this)
    const options = { theme: 'bootstrap', position: 'top right' }
    const additionalOptions = el.data('colorpicker-options')
    el.minicolors($.extend(options, additionalOptions))
  })
}

// unified pwstrength builder for client side password strength validation
// https://github.com/ablanco/jquery.pwstrength.bootstrap
Forms.initPasswordChecker = function () {
  require('pwstrength-bootstrap/dist/pwstrength-bootstrap.min')

  const $passwordInput = $('input.password-checker:password')
  if ($passwordInput.length === 0) return
  const $form = $($passwordInput[0].form)
  const $formGroup = $passwordInput.parents('.form-group')
  $passwordInput.pwstrength({
    common: {
      minChar: 6,
      onScore: function (options, word, totalScoreCalculated) {
        const scores = options.ui.scores
        const errors = options.instances.errors
        const bad = totalScoreCalculated < scores[1] || errors.length > 0
        const normal = totalScoreCalculated > scores[1] && totalScoreCalculated < scores[3] && errors.length === 0
        const good = totalScoreCalculated > scores[3] && errors.length === 0
        if ($formGroup.length) {
          $formGroup.toggleClass('has-error', bad)
          $formGroup.toggleClass('has-warning', normal)
          $formGroup.toggleClass('has-success', good)
        }
        $form.find('[type="submit"]').prop('disabled', bad)
        return totalScoreCalculated
      }
    },
    rules: {
      activated: {
        wordSequences: false,
        wordThreeNumbers: false,
        wordTwoSpecialChar: false,
        wordUpperLowerCombo: false,
        wordLetterNumberCombo: false,
        wordLetterNumberCharCombo: false
      }
    },
    ui: {
      container: '.user_password',
      colorClasses: ['bg-text-danger', 'bg-text-danger', 'bg-text-warning', 'bg-text-warning', 'bg-text-success', 'bg-text-success'],
      showPopover: false,
      showProgressBar: false,
      showErrors: true,
      showStatus: true,
      showVerdicts: true,
      useVerdictCssClass: true
    },
    i18n: {
      t: (key) => I18n.t(`layouts.password_checker.${key}`)
    }
  })
}

Forms.initAutoSubmit = function () {
  $(document).on('change', 'form.auto-submit', function (e) {
    let element = e.target

    if (e.originalEvent && e.originalEvent.target) {
      element = e.originalEvent.target
    };

    if (!$(element).hasClass('prevent-auto-submit')) {
      $(this).trigger('submit')
    }
  })
}

Forms.initScrollableLabel = function () {
  $('.scrollable-label').on('mouseenter', function (e) {
    const innerWidth = e.target.scrollWidth
    const actualWidth = e.target.offsetWidth
    const scrollable = innerWidth > actualWidth
    const label = $(e.target)
    if (scrollable) {
      label.css({ textIndent: 0, width: actualWidth })
      const icon = label.find('i')
      let indent = innerWidth - actualWidth - parseFloat(e.target.style.textIndent) + 5
      if (icon.length) indent -= icon[0].scrollWidth / 3
      const speed = indent * 18 // show 1px per 18ms
      label.stop().animate({ textIndent: `-${indent}px` }, speed, 'linear')
      label.one('mouseleave', function (e) {
        label.stop().animate({ textIndent: '0' }, speed / 3, 'linear', function () {
          label.removeAttr('style')
        })
      })
    }
  })
}

Forms.htmlDecode = function (input) {
  const doc = new DOMParser().parseFromString(input, 'text/html')
  return doc.documentElement.textContent
}

Forms.initCurrencyInputs = function (element) {
  $('.input-currency', element).inputmask('localized_numeric')
}

Forms.smoothScrollingOnIOS = function () {
  if (Forms._smoothScrollingInitialized) return
  Forms._smoothScrollingInitialized = true

  let startY = 0
  let startX = 0
  let moved = false

  const INTERACTIVE_SELECTOR = `
    input,
    textarea,
    select,
    .select2-container,
    .select2-selection,
    .select2-search__field,
    .rs-container,
    .rs__control
  `

  document.addEventListener('touchstart', e => {
    startY = e.touches[0].clientY
    startX = e.touches[0].clientX
    moved = false
  }, { passive: true })

  document.addEventListener('touchmove', e => {
    const deltaY = Math.abs(e.touches[0].clientY - startY)
    const deltaX = Math.abs(e.touches[0].clientX - startX)
    if (deltaY > 10 && deltaY > deltaX) {
      moved = true
    }
  }, { passive: true })

  document.addEventListener('touchend', e => {
    if (!moved) return

    if (e.target.closest(INTERACTIVE_SELECTOR)) {
      e.preventDefault()

      if (document.activeElement) {
        document.activeElement.blur()
      }
    }
  }, { passive: false })

  // Inject a style tag last in <head> to override ALL other CSS with 16px font-size
  Forms.preventIOSAutoZoom()
}

Forms.isIOSSafari = function () {
  const userAgent = navigator.userAgent
  const isSafari = /^((?!chrome|android).)*safari/i.test(userAgent)
  const isIOSDevice = /iPhone|iPad|iPod/i.test(userAgent)
  const isIPadOSDesktop = /Macintosh/i.test(userAgent) && navigator.maxTouchPoints > 1

  return isSafari && (isIOSDevice || isIPadOSDesktop)
}

// Sets font-size on inputs to prevent iOS auto-zoom on input focus.
// iOS zooms when the VISUAL font-size < ~16px. At 0.78 scale, 16px CSS = 12.48px visual.
// Solution: compute the CSS font-size needed so that CSS × scale >= 16px visual.
// This avoids minimum-scale=1, which causes scroll resistance across all pages.
Forms.preventIOSAutoZoom = function () {
  if (!Forms.isIOSSafari()) return

  const applyFix = function () {
    const existing = document.getElementById('ios-no-zoom')

    // Calculate the minimum CSS font-size so visual size >= 16px at the current scale.
    const currentScale = (window.visualViewport && window.visualViewport.scale) || 1
    const minFontSize = Math.max(16, Math.ceil(16 / currentScale))

    if (existing) {
      // Update font-size if scale has changed since last injection.
      existing.textContent = existing.textContent.replace(/font-size:\s*\d+px/, 'font-size: ' + minFontSize + 'px')
      return
    }

    const style = document.createElement('style')
    style.id = 'ios-no-zoom'
    // data-turbo-permanent prevents Turbo Drive head-merge from removing this element
    // on page navigation, which would silently break the auto-zoom prevention.
    style.setAttribute('data-turbo-permanent', '')
    style.textContent = [
      'input.form-control, input[type="text"], input[type="email"], input[type="password"],',
      'input[type="number"], input[type="tel"], input[type="search"], input[type="url"],',
      'input[type="date"], input[type="datetime-local"], input:not([type]),',
      'textarea, textarea.form-control, select, select.form-control,',
      '.select2-search__field {',
      '  font-size: ' + minFontSize + 'px !important;',
      '}'
    ].join('\n')
    document.head.appendChild(style)
  }

  // Always call applyFix so the style is re-injected if Turbo removed it despite
  // data-turbo-permanent (e.g. first navigation before the attribute takes effect).
  applyFix()

  // Only register the resize listener once to avoid duplicates across navigations.
  if (Forms._iosAutoZoomInitialized) return
  Forms._iosAutoZoomInitialized = true

  // Re-apply if the user pinch-zooms the page, since scale changes the required font-size.
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', applyFix)
  }
}
